var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroTaglineUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 12,
    viewBox: "0 0 400 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00012 7.99996C4.00012 7.99996 132 1.99996 200 3.99996C268 5.99996 396 9.99996 396 9.99996",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroTaglineUnderline);
export default __webpack_public_path__ + "static/media/hero-tagline-underline.d7f0815d2dcfff259fc75166cf60d22d.svg";
export { ForwardRef as ReactComponent };